<button mat-icon-button matTooltip="Add Review" (click)="addReview()">
    <mat-icon>pageview</mat-icon>
</button>
